// Activity type configuration for the unified timeline
export const ACTIVITY_TYPES = [
  { id: 'note', label: 'Note', icon: 'mdi:note-text-outline', color: '#2065D1' },
  { id: 'call', label: 'Call', icon: 'mdi:phone', color: '#54D62C' },
  { id: 'meeting', label: 'Meeting', icon: 'mdi:calendar-clock', color: '#FFC107' },
  { id: 'email', label: 'Email', icon: 'mdi:email-outline', color: '#1890FF' },
  { id: 'task', label: 'Task', icon: 'mdi:checkbox-marked-circle-outline', color: '#FF6C40' },
  { id: 'status_change', label: 'Status Change', icon: 'mdi:swap-horizontal', color: '#9C27B0' },
  { id: 'sms', label: 'SMS', icon: 'mdi:message-text-outline', color: '#00AB55' },
  { id: 'document_request', label: 'Document', icon: 'mdi:file-document-check-outline', color: '#7635DC' },
];

/**
 * Returns the icon, color, and label for a given activity type.
 * @param {string} type - Activity type ID
 * @returns {{ id: string, label: string, icon: string, color: string }}
 */
export function getActivityMeta(type) {
  const match = ACTIVITY_TYPES.find((a) => a.id === type);
  return match || { id: type, label: type, icon: 'mdi:help-circle-outline', color: '#919EAB' };
}
